export default "/assets/pencil-gray.svg";